import React from 'react'

const SvgMapLocation = ({ title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 17 17" {...props}>
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h20v20H-2z" />
      <path
        d="M13.833.666a1.5 1.5 0 0 1 1.895 1.898l-4.07 12.215a1.5 1.5 0 0 1-2.852-.016L7.06 9.315 1.634 7.563a1.5 1.5 0 0 1-.011-2.851L13.833.666z"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default SvgMapLocation
